import React, { useEffect, useState } from 'react';
import { Row } from 'antd';

import { TitleSections } from '../../../../components/TitleSections';
import InfoProprietarioCavaloLeitura from './infoProprietarioCavaloLeitura';
import InfoProprietarioCavaloEdicao from './infoProprietarioCavaloEdicao';
import { useAuth } from '../../../../hooks/auth';

export function InfoProprietarioCavalo({
  dadosProp,
  carregarSolicitacaoAtual,
  setSpinning,
  tipoValidacao,
}) {
  const [readOnly, setReadOnly] = useState(true);
  const tituloSecao = dadosProp?.detalheTipoCadastro;
  const [isAdministrador, setIsAdministrador] = useState(false);
  const { temPermissao } = useAuth();
  useEffect(() => {
    const isAdmin =
      temPermissao(['EditarCadastroPainel']) && tipoValidacao === 1;
    setIsAdministrador(isAdmin);
  }, [temPermissao]);
  return (
    <>
      <TitleSections
        title={`Dados cadastrais do ${tituloSecao}`}
        withButton={!!isAdministrador}
        buttonText="Editar"
        readOnly={readOnly}
        setReadOnly={setReadOnly}
      />
      <Row
        justify="space-between"
        style={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
        }}
      >
        {readOnly ? (
          <InfoProprietarioCavaloLeitura dadosProp={dadosProp} />
        ) : (
          <InfoProprietarioCavaloEdicao
            dadosProp={dadosProp}
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
            setSpinning={setSpinning}
          />
        )}
      </Row>
    </>
  );
}
